module.exports = __webpack_public_path__ + "img/img_6.bb64cd43.png";